import {ServiceClass} from '@/decorators';
import {AnyObject} from '@/globals';
import {PlanModel, PlanVersionRequestModel} from '../models/payment/payment.models';
import {BaseApi} from './base.api';

@ServiceClass()
export class AdminPlanApiService extends BaseApi {
    public getPlans(filter: AnyObject = {}) {
        return this.GET_RequestAsync<Array<PlanModel>>(`${this.ApiUrl}/admin/plans?filter=${encodeURIComponent(JSON.stringify(filter))}`);
    }

    public createPlanVersion(payload: PlanVersionRequestModel) {
        return this.POST_RequestAsync<PlanModel>(`${this.ApiUrl}/admin/plans`, payload);
    }

    public createPlanVersionForCode(code: string, payload: Omit<PlanVersionRequestModel, 'code'>) {
        return this.POST_RequestAsync<PlanModel>(`${this.ApiUrl}/admin/plans/${code}/versions`, payload);
    }

    public deactivatePlan(planId: string) {
        return this.PATCH_RequestAsync<void>(`${this.ApiUrl}/admin/plans/${planId}/deactivate`, {});
    }
}
